"use client"

import { ShoppingCartIcon } from "@/app/icons/shopping-cart"
import { PriceInCrypto } from "@/app/price"
import { Trans } from "@lingui/react/macro"
import {
  Badge,
  Button,
  Card,
  CardContent,
  CardHeader,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { NftMiniature } from "../../miniautre/nft-miniature"
import { NftsToBuyMoleculeReatom } from "./molecule.reatom"
import { RemoveNftSelection } from "./remove-nft-selection"

export const SelectedNftsToBuy = reatomComponent(() => {
  const { selectedNftsToBuy } = useMolecule(NftsToBuyMoleculeReatom)
  const nfts = selectedNftsToBuy()

  if (!nfts.length) return null

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button className="relative" size="icon" variant="secondary">
          <Badge className="-translate-y-1/2 absolute top-0 right-0 translate-x-1/2 transform bg-brand px-1 py-[1px] text-muted hover:bg-brand">
            {nfts.length}
          </Badge>
          <ShoppingCartIcon />
        </Button>
      </PopoverTrigger>
      <PopoverContent side="top" align="end" sideOffset={24} asChild>
        <Card className="flex h-[300px] flex-col gap-4 rounded-xl px-2 py-4">
          <CardHeader className="px-3 py-0">
            <Trans>Cart</Trans>
          </CardHeader>
          <CardContent className="flex flex-1 flex-col gap-4 overflow-y-auto px-3 py-0">
            {nfts.map((nft) => (
              <div
                key={nft.id}
                className="group flex w-full items-center justify-between gap-3"
              >
                <NftMiniature
                  className="pointer-events-none h-9 overflow-x-hidden"
                  nft={nft}
                />
                <PriceInCrypto
                  className="shrink-0 group-hover:hidden"
                  {...nft.price}
                />
                <RemoveNftSelection
                  className="hidden group-hover:block"
                  nftId={nft.id}
                />
              </div>
            ))}
          </CardContent>
        </Card>
      </PopoverContent>
    </Popover>
  )
}, "SelectedNftsToBuy")
